<template>
  <v-layout
    column
    class="page"
  >
    <!-- top bar -->
    <v-app-bar
      app
      height="52"
      color="#fff"
      flat
    >
      <v-row>
        <v-col>
          <v-btn
            small
            color="success"
            @click="reloadOrders"
          >
            <v-icon left>
              mdi-refresh
            </v-icon> {{ $t('orders.refresh_list') }}
          </v-btn>
        </v-col>
      </v-row>
    </v-app-bar>

    <loader v-if="isLoading" />

    <div v-if="!isLoading">
      <div v-if="getDays.length">
        <div class="text-right">
          {{ getStoreName }}
        </div>

        <Day
          v-for="day in getDays"
          :key="day.date"
          :day="day"
          class="day"
        />
      </div>

      <div
        v-if="!getDays.length"
        class="red lighten-4 pa-2"
      >
        {{ $t('orders.info.no_orders_found') }}
      </div>
    </div>
  </v-layout>
</template>

<script>
import { mapGetters } from 'vuex'
import Day from './Day'
import Loader from '@/components/System/Layout/Loader'
import StoreHelper from './../Helpers/Store'

export default {
  components: {
    Day,
    Loader
  },
  computed: {
    ...mapGetters('orders', [
      'isLoading',
      'getStore',
      'getDays'
    ]),

    getStoreName () {
      return StoreHelper.getStoreName(this.getStore)
    }
  },

  mounted () {
    this.$store.dispatch('orders/fetchOrders')
  },

  methods: {
    reloadOrders () {
      this.$store.dispatch('orders/fetchOrders')
    }
  }
}
</script>

<style lang="scss" scoped>
.page-title {
  margin-bottom: 30px;
  font-weight: 400;
}

.day {
  margin-bottom: 70px;
}
</style>

<style lang="scss">
.order-list-table {
  table {
    border: thin solid rgba(0, 0, 0, 0.12);

    tbody td {
      padding-top: 5px;
      padding-bottom: 5px;
    }
  }
}

</style>
